import { takeEvery, all } from 'redux-saga/effects'

import { actionTypes } from '../constants'

import getFields from './getFields'
import submitClientData from './submitClientData'

export { getFields }

export default function* () {
  yield all([
    takeEvery<actionTypes.FETCH, any>(actionTypes.FETCH, getFields),
    takeEvery<actionTypes.SUBMIT, any>(actionTypes.SUBMIT, submitClientData),
  ])
}
